"use client";

import { CURRENCIES, DEFAULT_CURRENCY } from "@/constants/currency";
import { useModal } from "@/contexts/ModalContext";
import Cookies from "js-cookie";
import { createContext, useContext, useEffect, useState } from "react";

const CURRENCY_COOKIE_NAME = "saka-currency";

const CurrencyContext = createContext();

function getInitialCurrency() {
  if (typeof window === "undefined") return DEFAULT_CURRENCY;
  const saved = Cookies.get(CURRENCY_COOKIE_NAME);
  return saved && CURRENCIES[saved] ? saved : DEFAULT_CURRENCY;
}

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(null);
  const languageAndCurrencyModal = useModal("language-and-currency-modal");

  useEffect(() => {
    // Sync currency from cookie on mount (hydration sonrası cookie farklıysa güncelle)
    const savedCurrency = Cookies.get(CURRENCY_COOKIE_NAME);
    if (savedCurrency && CURRENCIES[savedCurrency]) {
      setCurrency(savedCurrency);
    }
  }, []);

  const showLanguageAndCurrencyModal = (params) => {
    languageAndCurrencyModal.open({
      isBottomSheet: true,
      showCloseButton: false,
      className: "!overflow-visible",
      contentClassName: "!overflow-visible p-4",
      size: "sm",
    });
  };

  const hideLanguageAndCurrencyModal = () => {
    languageAndCurrencyModal.close();
  };

  const getCurrencyInfo = () => {
    return CURRENCIES[currency];
  };

  const value = {
    currency,
    getCurrencyInfo,
    currencies: CURRENCIES,
    showLanguageAndCurrencyModal,
    hideLanguageAndCurrencyModal,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return context;
}
